<template>
  <div class="wrapper-setting">
    <div style="background: #fff;">
      <el-tabs v-model="activeName" style="padding:20px;">
        <el-tab-pane label="获取Code" name="first">
          <br>
          <div class="api-sub-content">
            <p class="linep">协议规范：</p>
            <div class="simpleline"><strong>接口协议：</strong><span class="url">HTTP POST JSON</span></div>
            <div class="simpleline"><strong>接口地址：</strong><span
                class="url">{{ site }}api/getCode?name=上海***有限公司</span>
            </div>
            <div class="simpleline"><strong>模型评分接口监控：</strong><span class="url">暂无</span></div>
            <div class="simpleline">
              <a class="api-test-tools" href="/box/index/id/54" target="_blank"
                 rel="noopener noreferrer">API测试工具</a>
            </div>
            <div class="simpleTable">
              <p class="linep">请求参数说明：</p>
              <table class="api-table" cellspacing="0" cellpadding="0" style="width: 100%;">
                <tbody>
                <tr class="title">
                  <th width="20"></th>
                  <th width="80">字段名</th>
                  <th width="60">类型</th>
                  <th width="60">上级节点</th>
                  <th width="60">是否必须</th>
                  <th width="250">样例</th>
                  <th width="200">说明</th>
                  <th width="100">备注</th>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td class="url">appKey</td>
                  <td class="url">String</td>
                  <td class="url">root</td>
                  <td>是</td>
                  <td>-</td>
                  <td>应用标识</td>
                  <td>由我们提供</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td class="url">serviceKey</td>
                  <td class="url">String</td>
                  <td class="url">root</td>
                  <td>是</td>
                  <td>-</td>
                  <td>服务标识</td>
                  <td>由我们提供</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td class="url">userKey</td>
                  <td class="url">String</td>
                  <td class="url">root</td>
                  <td>是</td>
                  <td>-</td>
                  <td>用户标识</td>
                  <td>由我们提供</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td class="url">modelVersion</td>
                  <td class="url">String</td>
                  <td class="url">root</td>
                  <td>是</td>
                  <td>v2.0</td>
                  <td>模型版本号</td>
                  <td>由我们提供</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td class="url">data</td>
                  <td class="url">String</td>
                  <td class="url">root</td>
                  <td>是</td>
                  <td>68ad38ca959ccfa5fb2360ab7a62a705</td>
                  <td>数据主体，md5加密或json格式</td>
                  <td>用户提供</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td class="url">dataType</td>
                  <td class="url">String</td>
                  <td class="url">root</td>
                  <td>是</td>
                  <td>idCard/jsonTex</td>
                  <td>数据类型</td>
                  <td>用户提供</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td class="url">encryptType</td>
                  <td class="url">String</td>
                  <td class="url">root</td>
                  <td>是</td>
                  <td>md5/none</td>
                  <td>数据加密类型</td>
                  <td>用户提供</td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="simpleTable">
              <p class="linep">请求参数json案例：</p>
              <div class="prediv">
							<pre>
      {
        "appKey": "app_key",
        "serviceKey": "service_key",
        "userKey":"d57f07b02f71be9d",
        "modelVersion":"v2.0",
        "data":"68ad38ca959ccfa5fb2360ab7a62a705",
        "dataType":"idCard",
        "encryptType":"md5"
      }
    </pre>
              </div>
            </div>
            <div class="simpleTable">
              <p class="linep">返回参数说明：</p>
              <table class="api-table" border="0" cellspacing="0" cellpadding="0">
                <tbody>
                <tr class="title">
                  <th width="20"></th>
                  <th>参数名称</th>
                  <th>类型</th>
                  <th>上下节点</th>
                  <th>说明</th>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td class="url">status</td>
                  <td class="url">Integer</td>
                  <td class="url">-</td>
                  <td class="url">响应状态码。0成功 1请求成功但没有获取到数据 100失败</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td class="url">resultCode</td>
                  <td class="url">String</td>
                  <td class="url">-</td>
                  <td class="url"> 结束码。详情请看下方码表</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td class="url">message</td>
                  <td class="url">String</td>
                  <td class="url">-</td>
                  <td class="url">提示信息</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td class="url">currentTime</td>
                  <td class="url">Date</td>
                  <td class="url">-</td>
                  <td class="url">响应返回时间戳</td>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td class="url">data</td>
                  <td class="url">Map</td>
                  <td class="url">-</td>
                  <td class="url">响应数据集Map</td>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td class="url">score</td>
                  <td class="url">Double</td>
                  <td class="url">data</td>
                  <td class="url">评分结果</td>
                </tr>

                </tbody>
              </table>
            </div>
            <div class="simpleTable">
              <p class="linep">JSON返回示例：</p>
              <div class="prediv">
							<pre>
       /****成功示例**/
      {
        "status": 0,
        "resultCode": "match_data",
        "message": "执行成功",
        "currentTime": 1521183348685,
        "data": {
            "score": "0.9948"
        }
      }

       /****失败示例**/
      {
          "status": 100,
          "resultCode": "auth_error",
          "message": "认证失败，鉴权未通过",
          "currentTime": 1495632574458,
          "data": {
          }
      }</pre>
              </div>
            </div>
            <div class="simpleTable">
              <p class="linep">结束码表说明：</p>
              <table class="api-table" border="0" cellspacing="0" cellpadding="0">
                <tbody>
                <tr class="title">
                  <th width="20"></th>
                  <th>结束码</th>
                  <th>说明</th>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td class="url">match_data</td>
                  <td class="url">执行成功</td>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td class="url">unmatch_data</td>
                  <td class="url">执行成功,未匹配到数据</td>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td class="url">param_error</td>
                  <td class="url">认证失败，参数错误</td>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td class="url">auth_error</td>
                  <td class="url">认证失败，鉴权未通过</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td class="url">system_error</td>
                  <td class="url">执行失败，系统内部错误</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="获取专利" name="second">
          <br>
          <div class="api-sub-content">
            <p class="linep">协议规范：</p>
            <div class="simpleline"><strong>接口协议：</strong><span class="url">HTTP POST JSON</span></div>
            <div class="simpleline"><strong>接口地址：</strong><span
                class="url">{{ site }}api/patent?code=914201126****59011&key=23456789</span>
            </div>
            <div class="simpleline"><strong>模型评分接口监控：</strong><span class="url">暂无</span></div>
            <div class="simpleline">
              <a class="api-test-tools" href="/box/index/id/54" target="_blank"
                 rel="noopener noreferrer">API测试工具</a>
            </div>
            <div class="simpleTable">
              <p class="linep">请求参数说明：</p>
              <table class="api-table" cellspacing="0" cellpadding="0" style="width: 100%;">
                <tbody>
                <tr class="title">
                  <th width="20"></th>
                  <th width="80">字段名</th>
                  <th width="60">类型</th>
                  <th width="100">上级节点</th>
                  <th width="60">是否必须</th>
                  <th width="200">样例</th>
                  <th width="200">说明</th>
                  <th width="100">备注</th>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td class="url">appKey</td>
                  <td class="url">String</td>
                  <td class="url">root</td>
                  <td>是</td>
                  <td>-</td>
                  <td>应用标识</td>
                  <td>由我们提供</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td class="url">serviceKey</td>
                  <td class="url">String</td>
                  <td class="url">root</td>
                  <td>是</td>
                  <td>-</td>
                  <td>服务标识</td>
                  <td>由我们提供</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td class="url">userKey</td>
                  <td class="url">String</td>
                  <td class="url">root</td>
                  <td>是</td>
                  <td>-</td>
                  <td>用户标识</td>
                  <td>由我们提供</td>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td class="url">data</td>
                  <td class="url">String</td>
                  <td class="url">root</td>
                  <td>是</td>
                  <td>-</td>
                  <td>数据主体，json格式</td>
                  <td>用户提供</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td class="url">encryptType</td>
                  <td class="url">String</td>
                  <td class="url">root</td>
                  <td>是</td>
                  <td>md5/none</td>
                  <td>数据加密类型</td>
                  <td>用户提供</td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="simpleTable">
              <p class="linep">请求参数json案例：</p>
              <div class="prediv">
							<pre>{
        "appKey":"",
        "serviceKey":"",
        "userKey":"",
        "data":{
            "idCard":"060017c70edb8ae84bc7f38f723fac0d",
            "phone":"db8ece6a58e87adf6bfb9da9719a9b31",
            "name":"杨洋",
            "type":"type",
            "source":"source"
        },
        "encryptType":"md5"
    }
    </pre>
              </div>
            </div>
            <div class="simpleTable">
              <p class="linep">返回参数说明：</p>
              <table class="api-table" border="0" cellspacing="0" cellpadding="0">
                <tbody>
                <tr class="title">
                  <th width="20"></th>
                  <th>参数名称</th>
                  <th>类型</th>
                  <th>上下节点</th>
                  <th>说明</th>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td class="url">status</td>
                  <td class="url">Integer</td>
                  <td class="url">-</td>
                  <td class="url">响应状态码。0成功 1请求成功但没有获取到数据 100失败</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td class="url">resultCode</td>
                  <td class="url">String</td>
                  <td class="url">-</td>
                  <td class="url"> 结束码</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td class="url">message</td>
                  <td class="url">String</td>
                  <td class="url">-</td>
                  <td class="url">提示信息</td>
                </tr>

                </tbody>
              </table>
            </div>
            <div class="simpleTable">
              <p class="linep">JSON返回示例：</p>
              <div class="prediv">
							<pre>
       /****成功示例**/

            身份证姓名和手机号都匹配
    {
      "status": 0,
      "resultCode": "match_data",
      "message": "执行成功",
      "currentTime": 1529982895143,
      "data": {
        "result": 0,
        "info": "三信息匹配成功"
      }
    }

    身份证和手机号匹配，姓名不匹配

    {
      "status": 0,
      "resultCode": "match_data",
      "message": "执行成功",
      "currentTime": 1529982926409,
      "data": {
        "result": 101,
        "info": "手机匹配成功"
      }
    }

    身份证和姓名匹配，手机号不匹配

    {
      "status": 0,
      "resultCode": "match_data",
      "message": "执行成功",
      "currentTime": 1529982945610,
      "data": {
        "result": 102,
        "info": "姓名匹配成功"
      }
    }

    能获取到数据，但是手机号和姓名都不匹配

    {
      "status": 0,
      "resultCode": "match_data",
      "message": "执行成功",
      "currentTime": 1529982960265,
      "data": {
        "result": 103,
        "info": "信息不匹配"
      }
    }

       /****失败示例**/

    {
      "status": 0,
      "resultCode": "match_data",
      "message": "执行成功",
      "currentTime": 1529982974899,
      "data": {
        "result": 100,
        "info": "没有查询到数据"
      }
    }
        </pre>
              </div>
            </div>
            <div class="simpleTable">
              <p class="linep">结束码表说明：</p>
              <table class="api-table" border="0" cellspacing="0" cellpadding="0">
                <tbody>
                <tr class="title">
                  <th width="20"></th>
                  <th>结束码</th>
                  <th>说明</th>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td class="url">match_data</td>
                  <td class="url">执行成功</td>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td class="url">unmatch_data</td>
                  <td class="url">执行成功,未匹配到数据</td>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td class="url">param_error</td>
                  <td class="url">认证失败，参数错误</td>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td class="url">auth_error</td>
                  <td class="url">认证失败，鉴权未通过</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td class="url">system_error</td>
                  <td class="url">执行失败，系统内部错误</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

        </el-tab-pane>


        <el-tab-pane label="获取著作权" name="third">
          <br>
          <div class="api-sub-content">
            <p class="linep">协议规范：</p>
            <div class="simpleline"><strong>接口协议：</strong><span class="url">HTTP POST JSON</span></div>
            <div class="simpleline"><strong>接口地址：</strong><span
                class="url">{{ site }}api/info?code=914201126667559011&key=12345</span>
            </div>
            <div class="simpleline"><strong>模型评分接口监控：</strong><span class="url">暂无</span></div>
            <div class="simpleline">
              <a class="api-test-tools" href="/box/index/id/54" target="_blank"
                 rel="noopener noreferrer">API测试工具</a>
            </div>
            <div class="simpleTable">
              <p class="linep">请求参数说明：</p>
              <table class="api-table" cellspacing="0" cellpadding="0" style="width: 100%;">
                <tbody>
                <tr class="title">
                  <th width="20"></th>
                  <th width="80">字段名</th>
                  <th width="60">类型</th>
                  <th width="100">上级节点</th>
                  <th width="60">是否必须</th>
                  <th width="200">样例</th>
                  <th width="200">说明</th>
                  <th width="100">备注</th>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td class="url">appKey</td>
                  <td class="url">String</td>
                  <td class="url">root</td>
                  <td>是</td>
                  <td>-</td>
                  <td>应用标识</td>
                  <td>由我们提供</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td class="url">serviceKey</td>
                  <td class="url">String</td>
                  <td class="url">root</td>
                  <td>是</td>
                  <td>-</td>
                  <td>服务标识</td>
                  <td>由我们提供</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td class="url">userKey</td>
                  <td class="url">String</td>
                  <td class="url">root</td>
                  <td>是</td>
                  <td>-</td>
                  <td>用户标识</td>
                  <td>由我们提供</td>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td class="url">data</td>
                  <td class="url">String</td>
                  <td class="url">root</td>
                  <td>是</td>
                  <td>-</td>
                  <td>数据主体，json格式</td>
                  <td>用户提供</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td class="url">encryptType</td>
                  <td class="url">String</td>
                  <td class="url">root</td>
                  <td>是</td>
                  <td>md5/none</td>
                  <td>数据加密类型</td>
                  <td>用户提供</td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="simpleTable">
              <p class="linep">请求参数json案例：</p>
              <div class="prediv">
							<pre>{
        "appKey":"",
        "serviceKey":"",
        "userKey":"",
        "data":{
            "idCard":"060017c70edb8ae84bc7f38f723fac0d",
            "phone":"db8ece6a58e87adf6bfb9da9719a9b31",
            "name":"杨洋",
            "type":"type",
            "source":"source"
        },
        "encryptType":"md5"
    }
    </pre>
              </div>
            </div>
            <div class="simpleTable">
              <p class="linep">返回参数说明：</p>
              <table class="api-table" border="0" cellspacing="0" cellpadding="0">
                <tbody>
                <tr class="title">
                  <th width="20"></th>
                  <th>参数名称</th>
                  <th>类型</th>
                  <th>上下节点</th>
                  <th>说明</th>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td class="url">status</td>
                  <td class="url">Integer</td>
                  <td class="url">-</td>
                  <td class="url">响应状态码。0成功 1请求成功但没有获取到数据 100失败</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td class="url">resultCode</td>
                  <td class="url">String</td>
                  <td class="url">-</td>
                  <td class="url"> 结束码</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td class="url">message</td>
                  <td class="url">String</td>
                  <td class="url">-</td>
                  <td class="url">提示信息</td>
                </tr>

                </tbody>
              </table>
            </div>
            <div class="simpleTable">
              <p class="linep">JSON返回示例：</p>
              <div class="prediv">
							<pre>
       /****成功示例**/

            身份证姓名和手机号都匹配
    {
      "status": 0,
      "resultCode": "match_data",
      "message": "执行成功",
      "currentTime": 1529982895143,
      "data": {
        "result": 0,
        "info": "三信息匹配成功"
      }
    }

    身份证和手机号匹配，姓名不匹配

    {
      "status": 0,
      "resultCode": "match_data",
      "message": "执行成功",
      "currentTime": 1529982926409,
      "data": {
        "result": 101,
        "info": "手机匹配成功"
      }
    }

    身份证和姓名匹配，手机号不匹配

    {
      "status": 0,
      "resultCode": "match_data",
      "message": "执行成功",
      "currentTime": 1529982945610,
      "data": {
        "result": 102,
        "info": "姓名匹配成功"
      }
    }

    能获取到数据，但是手机号和姓名都不匹配

    {
      "status": 0,
      "resultCode": "match_data",
      "message": "执行成功",
      "currentTime": 1529982960265,
      "data": {
        "result": 103,
        "info": "信息不匹配"
      }
    }

       /****失败示例**/

    {
      "status": 0,
      "resultCode": "match_data",
      "message": "执行成功",
      "currentTime": 1529982974899,
      "data": {
        "result": 100,
        "info": "没有查询到数据"
      }
    }
        </pre>
              </div>
            </div>
            <div class="simpleTable">
              <p class="linep">结束码表说明：</p>
              <table class="api-table" border="0" cellspacing="0" cellpadding="0">
                <tbody>
                <tr class="title">
                  <th width="20"></th>
                  <th>结束码</th>
                  <th>说明</th>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td class="url">match_data</td>
                  <td class="url">执行成功</td>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td class="url">unmatch_data</td>
                  <td class="url">执行成功,未匹配到数据</td>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td class="url">param_error</td>
                  <td class="url">认证失败，参数错误</td>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td class="url">auth_error</td>
                  <td class="url">认证失败，鉴权未通过</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td class="url">system_error</td>
                  <td class="url">执行失败，系统内部错误</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

        </el-tab-pane>


        <el-tab-pane label="获取股东" name="fourth">
          <br>
          <div class="api-sub-content">
            <p class="linep">协议规范：</p>
            <div class="simpleline"><strong>接口协议：</strong><span class="url">HTTP POST JSON</span></div>
            <div class="simpleline"><strong>接口地址：</strong><span
                class="url">{{ site }}api/holder?code=914201126667559011&key=12345</span>
            </div>
            <div class="simpleline"><strong>模型评分接口监控：</strong><span class="url">暂无</span></div>
            <div class="simpleline">
              <a class="api-test-tools" href="/box/index/id/54" target="_blank"
                 rel="noopener noreferrer">API测试工具</a>
            </div>
            <div class="simpleTable">
              <p class="linep">请求参数说明：</p>
              <table class="api-table" cellspacing="0" cellpadding="0" style="width: 100%;">
                <tbody>
                <tr class="title">
                  <th width="20"></th>
                  <th width="80">字段名</th>
                  <th width="60">类型</th>
                  <th width="100">上级节点</th>
                  <th width="60">是否必须</th>
                  <th width="200">样例</th>
                  <th width="200">说明</th>
                  <th width="100">备注</th>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td class="url">appKey</td>
                  <td class="url">String</td>
                  <td class="url">root</td>
                  <td>是</td>
                  <td>-</td>
                  <td>应用标识</td>
                  <td>由我们提供</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td class="url">serviceKey</td>
                  <td class="url">String</td>
                  <td class="url">root</td>
                  <td>是</td>
                  <td>-</td>
                  <td>服务标识</td>
                  <td>由我们提供</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td class="url">userKey</td>
                  <td class="url">String</td>
                  <td class="url">root</td>
                  <td>是</td>
                  <td>-</td>
                  <td>用户标识</td>
                  <td>由我们提供</td>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td class="url">data</td>
                  <td class="url">String</td>
                  <td class="url">root</td>
                  <td>是</td>
                  <td>-</td>
                  <td>数据主体，json格式</td>
                  <td>用户提供</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td class="url">encryptType</td>
                  <td class="url">String</td>
                  <td class="url">root</td>
                  <td>是</td>
                  <td>md5/none</td>
                  <td>数据加密类型</td>
                  <td>用户提供</td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="simpleTable">
              <p class="linep">请求参数json案例：</p>
              <div class="prediv">
							<pre>{
        "appKey":"",
        "serviceKey":"",
        "userKey":"",
        "data":{
            "idCard":"060017c70edb8ae84bc7f38f723fac0d",
            "phone":"db8ece6a58e87adf6bfb9da9719a9b31",
            "name":"杨洋",
            "type":"type",
            "source":"source"
        },
        "encryptType":"md5"
    }
    </pre>
              </div>
            </div>
            <div class="simpleTable">
              <p class="linep">返回参数说明：</p>
              <table class="api-table" border="0" cellspacing="0" cellpadding="0">
                <tbody>
                <tr class="title">
                  <th width="20"></th>
                  <th>参数名称</th>
                  <th>类型</th>
                  <th>上下节点</th>
                  <th>说明</th>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td class="url">status</td>
                  <td class="url">Integer</td>
                  <td class="url">-</td>
                  <td class="url">响应状态码。0成功 1请求成功但没有获取到数据 100失败</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td class="url">resultCode</td>
                  <td class="url">String</td>
                  <td class="url">-</td>
                  <td class="url"> 结束码</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td class="url">message</td>
                  <td class="url">String</td>
                  <td class="url">-</td>
                  <td class="url">提示信息</td>
                </tr>

                </tbody>
              </table>
            </div>
            <div class="simpleTable">
              <p class="linep">JSON返回示例：</p>
              <div class="prediv">
							<pre>
       /****成功示例**/

            身份证姓名和手机号都匹配
    {
      "status": 0,
      "resultCode": "match_data",
      "message": "执行成功",
      "currentTime": 1529982895143,
      "data": {
        "result": 0,
        "info": "三信息匹配成功"
      }
    }

    身份证和手机号匹配，姓名不匹配

    {
      "status": 0,
      "resultCode": "match_data",
      "message": "执行成功",
      "currentTime": 1529982926409,
      "data": {
        "result": 101,
        "info": "手机匹配成功"
      }
    }

    身份证和姓名匹配，手机号不匹配

    {
      "status": 0,
      "resultCode": "match_data",
      "message": "执行成功",
      "currentTime": 1529982945610,
      "data": {
        "result": 102,
        "info": "姓名匹配成功"
      }
    }

    能获取到数据，但是手机号和姓名都不匹配

    {
      "status": 0,
      "resultCode": "match_data",
      "message": "执行成功",
      "currentTime": 1529982960265,
      "data": {
        "result": 103,
        "info": "信息不匹配"
      }
    }

       /****失败示例**/

    {
      "status": 0,
      "resultCode": "match_data",
      "message": "执行成功",
      "currentTime": 1529982974899,
      "data": {
        "result": 100,
        "info": "没有查询到数据"
      }
    }
        </pre>
              </div>
            </div>
            <div class="simpleTable">
              <p class="linep">结束码表说明：</p>
              <table class="api-table" border="0" cellspacing="0" cellpadding="0">
                <tbody>
                <tr class="title">
                  <th width="20"></th>
                  <th>结束码</th>
                  <th>说明</th>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td class="url">match_data</td>
                  <td class="url">执行成功</td>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td class="url">unmatch_data</td>
                  <td class="url">执行成功,未匹配到数据</td>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td class="url">param_error</td>
                  <td class="url">认证失败，参数错误</td>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td class="url">auth_error</td>
                  <td class="url">认证失败，鉴权未通过</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td class="url">system_error</td>
                  <td class="url">执行失败，系统内部错误</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

        </el-tab-pane>


        <el-tab-pane label="获取高管" name="fifth">
          <br>
          <div class="api-sub-content">
            <p class="linep">协议规范：</p>
            <div class="simpleline"><strong>接口协议：</strong><span class="url">HTTP POST JSON</span></div>
            <div class="simpleline"><strong>接口地址：</strong><span
                class="url">{{ site }}api/staff?code=914201126667559011&key=12345</span>
            </div>
            <div class="simpleline"><strong>模型评分接口监控：</strong><span class="url">暂无</span></div>
            <div class="simpleline">
              <a class="api-test-tools" href="/box/index/id/54" target="_blank"
                 rel="noopener noreferrer">API测试工具</a>
            </div>
            <div class="simpleTable">
              <p class="linep">请求参数说明：</p>
              <table class="api-table" cellspacing="0" cellpadding="0" style="width: 100%;">
                <tbody>
                <tr class="title">
                  <th width="20"></th>
                  <th width="80">字段名</th>
                  <th width="60">类型</th>
                  <th width="100">上级节点</th>
                  <th width="60">是否必须</th>
                  <th width="200">样例</th>
                  <th width="200">说明</th>
                  <th width="100">备注</th>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td class="url">appKey</td>
                  <td class="url">String</td>
                  <td class="url">root</td>
                  <td>是</td>
                  <td>-</td>
                  <td>应用标识</td>
                  <td>由我们提供</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td class="url">serviceKey</td>
                  <td class="url">String</td>
                  <td class="url">root</td>
                  <td>是</td>
                  <td>-</td>
                  <td>服务标识</td>
                  <td>由我们提供</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td class="url">userKey</td>
                  <td class="url">String</td>
                  <td class="url">root</td>
                  <td>是</td>
                  <td>-</td>
                  <td>用户标识</td>
                  <td>由我们提供</td>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td class="url">data</td>
                  <td class="url">String</td>
                  <td class="url">root</td>
                  <td>是</td>
                  <td>-</td>
                  <td>数据主体，json格式</td>
                  <td>用户提供</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td class="url">encryptType</td>
                  <td class="url">String</td>
                  <td class="url">root</td>
                  <td>是</td>
                  <td>md5/none</td>
                  <td>数据加密类型</td>
                  <td>用户提供</td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="simpleTable">
              <p class="linep">请求参数json案例：</p>
              <div class="prediv">
							<pre>{
        "appKey":"",
        "serviceKey":"",
        "userKey":"",
        "data":{
            "idCard":"060017c70edb8ae84bc7f38f723fac0d",
            "phone":"db8ece6a58e87adf6bfb9da9719a9b31",
            "name":"杨洋",
            "type":"type",
            "source":"source"
        },
        "encryptType":"md5"
    }
    </pre>
              </div>
            </div>
            <div class="simpleTable">
              <p class="linep">返回参数说明：</p>
              <table class="api-table" border="0" cellspacing="0" cellpadding="0">
                <tbody>
                <tr class="title">
                  <th width="20"></th>
                  <th>参数名称</th>
                  <th>类型</th>
                  <th>上下节点</th>
                  <th>说明</th>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td class="url">status</td>
                  <td class="url">Integer</td>
                  <td class="url">-</td>
                  <td class="url">响应状态码。0成功 1请求成功但没有获取到数据 100失败</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td class="url">resultCode</td>
                  <td class="url">String</td>
                  <td class="url">-</td>
                  <td class="url"> 结束码</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td class="url">message</td>
                  <td class="url">String</td>
                  <td class="url">-</td>
                  <td class="url">提示信息</td>
                </tr>

                </tbody>
              </table>
            </div>
            <div class="simpleTable">
              <p class="linep">JSON返回示例：</p>
              <div class="prediv">
							<pre>
       /****成功示例**/

            身份证姓名和手机号都匹配
    {
      "status": 0,
      "resultCode": "match_data",
      "message": "执行成功",
      "currentTime": 1529982895143,
      "data": {
        "result": 0,
        "info": "三信息匹配成功"
      }
    }

    身份证和手机号匹配，姓名不匹配

    {
      "status": 0,
      "resultCode": "match_data",
      "message": "执行成功",
      "currentTime": 1529982926409,
      "data": {
        "result": 101,
        "info": "手机匹配成功"
      }
    }

    身份证和姓名匹配，手机号不匹配

    {
      "status": 0,
      "resultCode": "match_data",
      "message": "执行成功",
      "currentTime": 1529982945610,
      "data": {
        "result": 102,
        "info": "姓名匹配成功"
      }
    }

    能获取到数据，但是手机号和姓名都不匹配

    {
      "status": 0,
      "resultCode": "match_data",
      "message": "执行成功",
      "currentTime": 1529982960265,
      "data": {
        "result": 103,
        "info": "信息不匹配"
      }
    }

       /****失败示例**/

    {
      "status": 0,
      "resultCode": "match_data",
      "message": "执行成功",
      "currentTime": 1529982974899,
      "data": {
        "result": 100,
        "info": "没有查询到数据"
      }
    }
        </pre>
              </div>
            </div>
            <div class="simpleTable">
              <p class="linep">结束码表说明：</p>
              <table class="api-table" border="0" cellspacing="0" cellpadding="0">
                <tbody>
                <tr class="title">
                  <th width="20"></th>
                  <th>结束码</th>
                  <th>说明</th>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td class="url">match_data</td>
                  <td class="url">执行成功</td>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td class="url">unmatch_data</td>
                  <td class="url">执行成功,未匹配到数据</td>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td class="url">param_error</td>
                  <td class="url">认证失败，参数错误</td>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td class="url">auth_error</td>
                  <td class="url">认证失败，鉴权未通过</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td class="url">system_error</td>
                  <td class="url">执行失败，系统内部错误</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </el-tab-pane>


        <el-tab-pane label="招投标信息" name="sixth">
          <br>
          <div class="api-sub-content">
            <p class="linep">协议规范：</p>
            <div class="simpleline"><strong>接口协议：</strong><span class="url">HTTP POST JSON</span></div>
            <div class="simpleline"><strong>接口地址：</strong><span
                class="url">{{ site }}api/info?code=914201126667559011&key=12345</span>
            </div>
            <div class="simpleline"><strong>模型评分接口监控：</strong><span class="url">暂无</span></div>
            <div class="simpleline">
              <a class="api-test-tools" href="/box/index/id/54" target="_blank"
                 rel="noopener noreferrer">API测试工具</a>
            </div>
            <div class="simpleTable">
              <p class="linep">请求参数说明：</p>
              <table class="api-table" cellspacing="0" cellpadding="0" style="width: 100%;">
                <tbody>
                <tr class="title">
                  <th width="20"></th>
                  <th width="80">字段名</th>
                  <th width="60">类型</th>
                  <th width="100">上级节点</th>
                  <th width="60">是否必须</th>
                  <th width="200">样例</th>
                  <th width="200">说明</th>
                  <th width="100">备注</th>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td class="url">appKey</td>
                  <td class="url">String</td>
                  <td class="url">root</td>
                  <td>是</td>
                  <td>-</td>
                  <td>应用标识</td>
                  <td>由我们提供</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td class="url">serviceKey</td>
                  <td class="url">String</td>
                  <td class="url">root</td>
                  <td>是</td>
                  <td>-</td>
                  <td>服务标识</td>
                  <td>由我们提供</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td class="url">userKey</td>
                  <td class="url">String</td>
                  <td class="url">root</td>
                  <td>是</td>
                  <td>-</td>
                  <td>用户标识</td>
                  <td>由我们提供</td>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td class="url">data</td>
                  <td class="url">String</td>
                  <td class="url">root</td>
                  <td>是</td>
                  <td>-</td>
                  <td>数据主体，json格式</td>
                  <td>用户提供</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td class="url">encryptType</td>
                  <td class="url">String</td>
                  <td class="url">root</td>
                  <td>是</td>
                  <td>md5/none</td>
                  <td>数据加密类型</td>
                  <td>用户提供</td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="simpleTable">
              <p class="linep">请求参数json案例：</p>
              <div class="prediv">
							<pre>{
        "appKey":"",
        "serviceKey":"",
        "userKey":"",
        "data":{
            "idCard":"060017c70edb8ae84bc7f38f723fac0d",
            "phone":"db8ece6a58e87adf6bfb9da9719a9b31",
            "name":"杨洋",
            "type":"type",
            "source":"source"
        },
        "encryptType":"md5"
    }
    </pre>
              </div>
            </div>
            <div class="simpleTable">
              <p class="linep">返回参数说明：</p>
              <table class="api-table" border="0" cellspacing="0" cellpadding="0">
                <tbody>
                <tr class="title">
                  <th width="20"></th>
                  <th>参数名称</th>
                  <th>类型</th>
                  <th>上下节点</th>
                  <th>说明</th>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td class="url">status</td>
                  <td class="url">Integer</td>
                  <td class="url">-</td>
                  <td class="url">响应状态码。0成功 1请求成功但没有获取到数据 100失败</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td class="url">resultCode</td>
                  <td class="url">String</td>
                  <td class="url">-</td>
                  <td class="url"> 结束码</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td class="url">message</td>
                  <td class="url">String</td>
                  <td class="url">-</td>
                  <td class="url">提示信息</td>
                </tr>

                </tbody>
              </table>
            </div>
            <div class="simpleTable">
              <p class="linep">JSON返回示例：</p>
              <div class="prediv">
							<pre>
       /****成功示例**/

            身份证姓名和手机号都匹配
    {
      "status": 0,
      "resultCode": "match_data",
      "message": "执行成功",
      "currentTime": 1529982895143,
      "data": {
        "result": 0,
        "info": "三信息匹配成功"
      }
    }

    身份证和手机号匹配，姓名不匹配

    {
      "status": 0,
      "resultCode": "match_data",
      "message": "执行成功",
      "currentTime": 1529982926409,
      "data": {
        "result": 101,
        "info": "手机匹配成功"
      }
    }

    身份证和姓名匹配，手机号不匹配

    {
      "status": 0,
      "resultCode": "match_data",
      "message": "执行成功",
      "currentTime": 1529982945610,
      "data": {
        "result": 102,
        "info": "姓名匹配成功"
      }
    }

    能获取到数据，但是手机号和姓名都不匹配

    {
      "status": 0,
      "resultCode": "match_data",
      "message": "执行成功",
      "currentTime": 1529982960265,
      "data": {
        "result": 103,
        "info": "信息不匹配"
      }
    }

       /****失败示例**/

    {
      "status": 0,
      "resultCode": "match_data",
      "message": "执行成功",
      "currentTime": 1529982974899,
      "data": {
        "result": 100,
        "info": "没有查询到数据"
      }
    }
        </pre>
              </div>
            </div>
            <div class="simpleTable">
              <p class="linep">结束码表说明：</p>
              <table class="api-table" border="0" cellspacing="0" cellpadding="0">
                <tbody>
                <tr class="title">
                  <th width="20"></th>
                  <th>结束码</th>
                  <th>说明</th>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td class="url">match_data</td>
                  <td class="url">执行成功</td>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td class="url">unmatch_data</td>
                  <td class="url">执行成功,未匹配到数据</td>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td class="url">param_error</td>
                  <td class="url">认证失败，参数错误</td>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td class="url">auth_error</td>
                  <td class="url">认证失败，鉴权未通过</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td class="url">system_error</td>
                  <td class="url">执行失败，系统内部错误</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </el-tab-pane>


        <el-tab-pane label="产业链" name="seven">
          <br>
          <div class="api-sub-content">
            <p class="linep">协议规范：</p>
            <div class="simpleline"><strong>接口协议：</strong><span class="url">HTTP POST JSON</span></div>
            <div class="simpleline"><strong>接口地址：</strong><span
                class="url">{{ site }}api/info?code=914201126667559011&key=12345</span>
            </div>
            <div class="simpleline"><strong>模型评分接口监控：</strong><span class="url">暂无</span></div>
            <div class="simpleline">
              <a class="api-test-tools" href="/box/index/id/54" target="_blank"
                 rel="noopener noreferrer">API测试工具</a>
            </div>
            <div class="simpleTable">
              <p class="linep">请求参数说明：</p>
              <table class="api-table" cellspacing="0" cellpadding="0" style="width: 100%;">
                <tbody>
                <tr class="title">
                  <th width="20"></th>
                  <th width="80">字段名</th>
                  <th width="60">类型</th>
                  <th width="100">上级节点</th>
                  <th width="60">是否必须</th>
                  <th width="200">样例</th>
                  <th width="200">说明</th>
                  <th width="100">备注</th>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td class="url">appKey</td>
                  <td class="url">String</td>
                  <td class="url">root</td>
                  <td>是</td>
                  <td>-</td>
                  <td>应用标识</td>
                  <td>由我们提供</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td class="url">serviceKey</td>
                  <td class="url">String</td>
                  <td class="url">root</td>
                  <td>是</td>
                  <td>-</td>
                  <td>服务标识</td>
                  <td>由我们提供</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td class="url">userKey</td>
                  <td class="url">String</td>
                  <td class="url">root</td>
                  <td>是</td>
                  <td>-</td>
                  <td>用户标识</td>
                  <td>由我们提供</td>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td class="url">data</td>
                  <td class="url">String</td>
                  <td class="url">root</td>
                  <td>是</td>
                  <td>-</td>
                  <td>数据主体，json格式</td>
                  <td>用户提供</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td class="url">encryptType</td>
                  <td class="url">String</td>
                  <td class="url">root</td>
                  <td>是</td>
                  <td>md5/none</td>
                  <td>数据加密类型</td>
                  <td>用户提供</td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="simpleTable">
              <p class="linep">请求参数json案例：</p>
              <div class="prediv">
							<pre>{
        "appKey":"",
        "serviceKey":"",
        "userKey":"",
        "data":{
            "idCard":"060017c70edb8ae84bc7f38f723fac0d",
            "phone":"db8ece6a58e87adf6bfb9da9719a9b31",
            "name":"杨洋",
            "type":"type",
            "source":"source"
        },
        "encryptType":"md5"
    }
    </pre>
              </div>
            </div>
            <div class="simpleTable">
              <p class="linep">返回参数说明：</p>
              <table class="api-table" border="0" cellspacing="0" cellpadding="0">
                <tbody>
                <tr class="title">
                  <th width="20"></th>
                  <th>参数名称</th>
                  <th>类型</th>
                  <th>上下节点</th>
                  <th>说明</th>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td class="url">status</td>
                  <td class="url">Integer</td>
                  <td class="url">-</td>
                  <td class="url">响应状态码。0成功 1请求成功但没有获取到数据 100失败</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td class="url">resultCode</td>
                  <td class="url">String</td>
                  <td class="url">-</td>
                  <td class="url"> 结束码</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td class="url">message</td>
                  <td class="url">String</td>
                  <td class="url">-</td>
                  <td class="url">提示信息</td>
                </tr>

                </tbody>
              </table>
            </div>
            <div class="simpleTable">
              <p class="linep">JSON返回示例：</p>
              <div class="prediv">
							<pre>
       /****成功示例**/

            身份证姓名和手机号都匹配
    {
      "status": 0,
      "resultCode": "match_data",
      "message": "执行成功",
      "currentTime": 1529982895143,
      "data": {
        "result": 0,
        "info": "三信息匹配成功"
      }
    }

    身份证和手机号匹配，姓名不匹配

    {
      "status": 0,
      "resultCode": "match_data",
      "message": "执行成功",
      "currentTime": 1529982926409,
      "data": {
        "result": 101,
        "info": "手机匹配成功"
      }
    }

    身份证和姓名匹配，手机号不匹配

    {
      "status": 0,
      "resultCode": "match_data",
      "message": "执行成功",
      "currentTime": 1529982945610,
      "data": {
        "result": 102,
        "info": "姓名匹配成功"
      }
    }

    能获取到数据，但是手机号和姓名都不匹配

    {
      "status": 0,
      "resultCode": "match_data",
      "message": "执行成功",
      "currentTime": 1529982960265,
      "data": {
        "result": 103,
        "info": "信息不匹配"
      }
    }

       /****失败示例**/

    {
      "status": 0,
      "resultCode": "match_data",
      "message": "执行成功",
      "currentTime": 1529982974899,
      "data": {
        "result": 100,
        "info": "没有查询到数据"
      }
    }
        </pre>
              </div>
            </div>
            <div class="simpleTable">
              <p class="linep">结束码表说明：</p>
              <table class="api-table" border="0" cellspacing="0" cellpadding="0">
                <tbody>
                <tr class="title">
                  <th width="20"></th>
                  <th>结束码</th>
                  <th>说明</th>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td class="url">match_data</td>
                  <td class="url">执行成功</td>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td class="url">unmatch_data</td>
                  <td class="url">执行成功,未匹配到数据</td>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td class="url">param_error</td>
                  <td class="url">认证失败，参数错误</td>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td class="url">auth_error</td>
                  <td class="url">认证失败，鉴权未通过</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td class="url">system_error</td>
                  <td class="url">执行失败，系统内部错误</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>


<style scoped="scoped">
element.style {
  display: block;
}

.api-sub-content {
  float: left;
}

.api-sub-content .simpleline {
  line-height: 20px;
  padding-bottom: 16px;
  word-break: break-all;
  color: #777;
}

tbody {
  display: table-row-group;
  vertical-align: middle;
  border-color: inherit;
}

.simpleTable {
  margin-bottom: 50px;
}

.linep {
  font-weight: bold;
  color: #555;
  padding-left: 14px;
  height: 16px;
  line-height: 16px;
  margin-bottom: 18px;
  position: relative;
}

p {
  display: block;
  -webkit-margin-before: 1em;
  -webkit-margin-after: 1em;
  -webkit-margin-start: 0px;
  -webkit-margin-end: 0px;
}

.linep::before {
  content: '';
  width: 4px;
  height: 16px;
  background: #00aeff;
  border-radius: 2px;
  position: absolute;
  left: 0;
  top: 0;
}

.api-table {
  width: 100%;
  border: 1px solid #e7e7e7;
  text-align: left;
}

tr {
  display: table-row;
  vertical-align: inherit;
  border-color: inherit;
}

.api-table th {
  border-bottom: 1px solid #e7e7e7;
  background: #fbfbfb;
  color: #999;
  font-weight: normal;
  line-height: 38px;
}

.api-table td {
  border-bottom: 1px solid #e7e7e7;
  color: #666;
  line-height: 28px;
  padding: 6px 0;
}

td,
th {
  display: table-cell;
  vertical-align: inherit;
}

div {
  display: block;
}

table,
div,
img {
  border-collapse: collapse;
  border-spacing: 0;
}

.prediv pre {
  color: rgb(102, 102, 102);
  white-space: pre;
  line-height: 24px;
  font-family: 微软雅黑;
  padding: 20px 0px 20px 20px;
  margin: 10px 0px;
  overflow: hidden;
  border-width: 1px;
  border-style: solid;
  border-color: rgb(231, 231, 231);
  border-image: initial;
  border-radius: 4px;
  background: rgb(252, 252, 252);
}

html,
body,
ul,
li,
p,
h1,
h2,
h3,
h4,
h5,
h6,
input,
form,
dd,
dt,
dl,
ol,
caption,
td,
tr,
th,
hr,
header,
footer,
blockquote,
pre,
fieldset,
legend,
aside,
nav,
section {
  padding: 0;
  margin: 0;
}

.api-sub-content .simpleline strong {
  color: #555;
}

strong,
b {
  font-weight: bold;
}

.api-sub-content .simpleline .api-test-tools {
  display: block;
  width: 150px;
  height: 34px;
  line-height: 34px;
  color: #fff;
  background: #00bdff;
  text-align: center;
  border-radius: 2px;
  margin-bottom: 30px;
}

a {
  text-decoration: none;
}
</style>
<script>
export default {
  data() {
    return {
      activeName: 'first',
      site: 'http://www.datawill.cn/'
    }
  }
}
</script>



// WEBPACK FOOTER //
// Help.vue?61b8d4d8